import { createContext, useContext, useState, type ReactNode, type ReactElement } from "react";

export type ModeClass = "dark-mode" | "";

interface DarkModeState {
  darkMode: boolean;
  toggleDarkMode: () => void;
  modeClass: ModeClass;
}

interface DarkModeProviderProps {
  children: ReactNode;
}

const DarkModeContext = createContext<DarkModeState | undefined>(undefined);
const LOCAL_STORAGE_KEY = "darkMode";

export const DarkModeProvider = ({ children }: DarkModeProviderProps): ReactElement => {
  const [darkMode, setDarkMode] = useState<boolean>(
    () => localStorage.getItem(LOCAL_STORAGE_KEY) === "true"
  );

  const toggleDarkMode = (): void => {
    setDarkMode((prev) => {
      const next = !prev;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  const modeClass: ModeClass = darkMode ? "dark-mode" : "";

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode, modeClass }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export const useDarkMode = (): DarkModeState => {
  const context = useContext(DarkModeContext);
  if (!context) {
    throw new Error("useDarkMode debe ser utilizado dentro de un DarkModeProvider");
  }
  return context;
};
